export default function SuitcaseIcon({ className = 'text-alsero-dark-gray' }: { className?: string }) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M5 5.83333H15C15.9205 5.83333 16.6667 6.57952 16.6667 7.5V15.8333C16.6667 16.7538 15.9205 17.5 15 17.5H5C4.07953 17.5 3.33333 16.7538 3.33333 15.8333V7.5C3.33333 6.57952 4.07953 5.83333 5 5.83333Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M5 5.83333V4.16667C5 3.24619 5.74619 2.5 6.66667 2.5H13.3333C14.2538 2.5 15 3.24619 15 4.16667V5.83333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8.33333 10.8333H11.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

